
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    tag: {
      type: String,
      default: 'div',
    },
    gap: {
      type: String || Number,
    },
    align: {
      default: null,
    },
  },
  setup () {
    return {}
  },
})
